import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationUsage } from "../types";

export const getOrganizationUsage = (organizationId: string) =>
  apiProxyRequest<OrganizationUsage>(`/organizations/${organizationId}/usage`);
